import { useContext } from 'react'
import PropTypes from 'prop-types'
import useUpdateEffect from 'react-use/lib/useUpdateEffect'

import { AccordionContext } from './Accordion'

import theme from 'theme'

export default function Body({ loading = false, ...rest }) {
  const { expanded, accordionRef, disableScrollAnimation } = useContext(
    AccordionContext
  )

  useUpdateEffect(() => {
    // Expanded is `true`
    // Accordion ref is set
    // We're not inside our <OffCanvas /> component
    if (
      expanded &&
      accordionRef.current &&
      !accordionRef.current.closest('.OffCanvas') &&
      !disableScrollAnimation
    ) {
      const bodyRect = document.body.getBoundingClientRect()
      const elementRect = accordionRef.current.getBoundingClientRect()

      // This is a calculation that scrolls the window to the top of the accordion container when the `expanded` prop is altered. Takes into account the sticky header we have; as well as a tiny bit of top space (for aesthetics)
      window.scrollTo({
        top:
          elementRect.top -
          bodyRect.top -
          parseInt(
            getComputedStyle(document.documentElement).getPropertyValue(
              '--header-height'
            ),
            10
          ) *
            parseFloat(getComputedStyle(document.documentElement).fontSize) -
          theme.space[3],
        behavior: 'smooth'
      })
    }
  }, [expanded])

  return expanded ? (
    <div
      css={{
        width: '100%',
        backgroundColor: 'white',
        position: 'relative',
        minHeight: Boolean(loading) && theme.space[8],

        '&:last-child': {
          borderBottomLeftRadius: theme.borderRadius[0],
          borderBottomRightRadius: theme.borderRadius[0]
        },

        '&:not(:last-child)': {
          borderBottom: theme.border.base
        }
      }}
      {...rest}
    />
  ) : null
}

Body.propTypes = {
  expanded: PropTypes.bool,
  disableScrollAnimation: PropTypes.bool,
  loading: PropTypes.bool
}
